const userDataKey = 'UserData';
const tokenDataKey = 'Token';
const searchOptionsViewMode = 'search.options.viewMode';
const searchOptionsLiveSearch = 'search.options.liveSearch';

export { userDataKey, tokenDataKey, searchOptionsViewMode, searchOptionsLiveSearch };
